<script setup>
import { RouterLink } from 'vue-router'
import { useRoute } from 'vue-router'
import MagnifyingGlassChartIcon from 'Common/components/elements/icons/MagnifyingGlassChartIcon.vue'
import { JeteyeRoutes } from 'Modules/RouterSetup'
import { showReportSummary } from '@/featureFlags'

const route = useRoute()
</script>

<template>
  <div v-if="showReportSummary" class="self-center">
    <router-link
      class="box-sizing h-full flex align-center hover:cursor-pointerd"
      :to="{ name: JeteyeRoutes.SummaryReport, query: { ...route.query } }"
    >
      <el-button class="mr-2" type="primary" plain>
        <span class="px-2"> <MagnifyingGlassChartIcon /> Report Builder </span>
      </el-button>
    </router-link>
  </div>
</template>
